var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLightBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.545 10.781c-0.104-0.103-0.168-0.246-0.168-0.403 0-0.313 0.254-0.567 0.567-0.567 0.156 0 0.297 0.063 0.399 0.164l4.088 4.088v-13.49c-0-0.001-0-0.003-0-0.004 0-0.312 0.252-0.566 0.564-0.568h0c0.316 0.001 0.571 0.257 0.572 0.572v13.49l4.080-4.088c0.104-0.101 0.246-0.164 0.403-0.164s0.299 0.062 0.403 0.164l-0-0c0.105 0.103 0.169 0.245 0.169 0.403s-0.065 0.301-0.169 0.403l-5.056 5.056c-0.103 0.101-0.244 0.163-0.399 0.163s-0.297-0.062-0.399-0.164l0 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLightBottom);
export default __webpack_public_path__ + "static/media/arrow-light-bottom.3640c8d6.svg";
export { ForwardRef as ReactComponent };